module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/bean/asstes/img/dropdown.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/bean/asstes/img/dropdown.png
// module id = 1458
// module chunks = 418